import { render, staticRenderFns } from "./flove_image-edit.vue?vue&type=template&id=cb67a686&scoped=true"
import script from "./flove_image-edit.vue?vue&type=script&lang=js"
export * from "./flove_image-edit.vue?vue&type=script&lang=js"
import style0 from "./flove_image-edit.vue?vue&type=style&index=0&id=cb67a686&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb67a686",
  null
  
)

export default component.exports